// extracted by mini-css-extract-plugin
module.exports = {"item":"item__1PiMg","emailItem":"emailItem__3BWe1","text":"text__14Nci","active":"active__37A0q","counter":"counter__1hMLT"};